import { render, staticRenderFns } from "./netpayView.vue?vue&type=template&id=6760e16c&"
import script from "./netpayView.vue?vue&type=script&lang=js&"
export * from "./netpayView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "netpayView.vue"
export default component.exports